import { CommonResponse } from "@gtpl/shared-models/production-management";
import { Injectable, Query } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { AssetsSaleAdapter } from "./entity/asset-sale.adapter";
import { AssetsSale } from "./entity/asset-sale.entity";
import { Repository, getManager } from "typeorm";
import { AssetsSaleDto } from "./dto/asset-sale.dto";
import appSettings from "apps/services/config";
import { ErrorResponse, GlobalVariableValues, MessageParameters } from "@gtpl/shared-models/common-models";
import { AssetByStatus } from "../open-assets/dto/asset-by-status.dto";
import { AssetByAssetCode } from "../asset-assignment/dto/get-by-assetCode.dto";
import { AssetStatusEnum } from "libs/shared-models/common-models/src/lib/enum/asset-status.enum";
import { Assets } from "../open-assets/open-assets-entity";
import { AssetTransaction } from "../open-assets/asset-transaction-entity";
import { AssetTransactionDto } from "../open-assets/dto/asset-transaction-dto";
import { AssetTransactionAdapter } from "../open-assets/dto/asset-transaction-adapter";
import moment from "moment";
import { WhatsappBroadCastService } from "@gtpl/shared-services/whatsapp-broad-cast";
import { AssetMaintainanceService } from "../asset-maintainance/asset-maintainance.service";
import { WhatsAppNotificationService } from "@gtpl/shared-services/notification-management";
import whatsApp from "apps/services/whatsapp";

@Injectable()
export class AssetsSaleService {
    constructor(
        private adapter: AssetsSaleAdapter,
        @InjectRepository(AssetsSale)
        private repo: Repository<AssetsSale>,
        @InjectRepository(Assets)
        private assetsRepository: Repository<Assets>,
        @InjectRepository(AssetTransaction)
        private assetsTransactionRepo: Repository<AssetTransaction>,
        private assetTransAdapter: AssetTransactionAdapter,
        private wtsAppBroadCatService: WhatsappBroadCastService,
        private wpService: WhatsAppNotificationService,


    ) { }

    async createAssetSale(saleDto: AssetsSaleDto): Promise<CommonResponse> {
        console.log(saleDto, 'saleDto')
        for (const sales of saleDto.saleDetails) {
            console.log(sales, 'sales')
            const assetsSale = new AssetsSale();
            assetsSale.assetSaleId = saleDto.assetSaleId;
            assetsSale.assetId = sales.assetId
            assetsSale.approvedBy = sales.approvedBy;
            assetsSale.assetSaleCost = sales.assetSaleCost;
            assetsSale.status = sales.status;
            assetsSale.reason = sales.reason;
            const assetSaleSave = await this.repo.save(assetsSale)
            const statusSave = await this.assetsRepository.update({ assetId: assetsSale.assetId }, { status: AssetStatusEnum.SOLD })

            const assetTransDto = new AssetTransactionDto();
            assetTransDto.assetId = saleDto.saleDetails[0].assetId;
            assetTransDto.status = AssetStatusEnum.SOLD;
            const assetTransEntity = this.assetTransAdapter.convertAssetTransactionDtoToEntity(assetTransDto)
            const statusTransactionSave = await this.assetsTransactionRepo.save(assetTransEntity)
            const manager = getManager()
            let qry = `SELECT a.asset_id , a.assets_code AS AssetCode , it.item_name AS assetName,asset_cost AS purchasedCost,
        SUM(a.asset_cost * POWER(0.95, YEAR(CURDATE()) - YEAR(a.date_of_purchased))) AS currentCost,a.expired_date AS expiredDate,ass.asset_sale_cost AS saleAmount FROM ` + appSettings.assets_db + `.assets_sale ass LEFT JOIN ` + appSettings.assets_db + `.assets a ON a.asset_id  = ass.asset_id LEFT JOIN ` + appSettings.masters_db + `.items it ON it.item_id = a.assets_name WHERE ass.asset_sale_id = ${assetSaleSave.assetSaleId}`;
            const data = await manager.query(qry)
            const parameters = [
                { "type": "text", "text": moment().format('DD-MM-YYYY') },
                { "type": "text", "text": data[0].assetName ? data[0].assetName : "No Data" },
                { "type": "text", "text": data[0].AssetCode ? data[0].AssetCode : "No Data" },
                { "type": "text", "text": data[0].expiredDate ? moment(data[0].expiredDate).format('DD-MM-YYYY') : "No Data" },
                { "type": "text", "text": data[0].purchasedCost ? Number(Number(data[0].purchasedCost).toFixed(0)).toLocaleString('en-IN') : "No Data" },
                { "type": "text", "text": data[0].currentCost ? Number(Number(data[0].currentCost).toFixed(0)).toLocaleString('en-IN') : "No Data" },
                { "type": "text", "text": data[0].saleAmount ? Number(Number(data[0].saleAmount).toFixed(0)).toLocaleString('en-IN') : "No Data" },
            ];
            for (const contact of whatsApp.contacts) {
                let statusFlag = true
                const req = await new MessageParameters(contact, 'asset_sale', parameters, "en_us")
                const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                console.log(messageStatus, '9999999')
                if (!messageStatus.status) {
                    statusFlag = false
                }
                else {
                    const testdata = 'INSERT INTO ' + appSettings.whatsapp_db + '.whatsapp_logs (contact_no,template_name,project_name,company_id,module_id) VALUES("' + contact + '","asset_sale","Brandix_assets",' + GlobalVariableValues.companyId + ',' + GlobalVariableValues.assetManagementmoduleId + ')'
                    const result = await manager.query(testdata)
                    const res = new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
                }
            }
        }
        return new CommonResponse(true, 1, 'Created Successfully')
    }

    async getAssetSaleDetails(req: AssetByAssetCode): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT ass.asset_sale_id,ass.asset_id,ass.approved_by,ass.asset_sale_cost,ass.status,ass.created_at,
        aas.assets_name,aas.assets_code,aas.asset_category,aas.asset_mode,aas.asset_type,aas.date_of_purchased,aas.insurance_date,aas.warrenty_expired_date,
        aas.status,lo.location_name,it.item_name,isc.item_sub_category,aas.expired_date,aas.plant,unc.unit_name,aas.asset_cost,emp.employee_name,datediff(date(now()),aas.date_of_purchased) as assetAge,dep.dept_name
        FROM `+ appSettings.assets_db + `.assets_sale ass
        LEFT JOIN `+ appSettings.assets_db + `.assets aas ON aas.asset_id = ass.asset_id
        LEFT JOIN `+ appSettings.assets_db + `.asset_location_mapping lom ON lom.asset_id = ass.asset_id
        LEFT JOIN `+ appSettings.assets_db + `.location lo ON lo.location_id = lom.location_id
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        LEFT JOIN `+ appSettings.masters_db + `.unitcodes unc ON unc.unit_code_id = aas.plant
        LEFT JOIN `+ appSettings.masters_db + `.employee_details emp ON emp.employee_id = ass.approved_by
        LEFT JOIN ` + appSettings.masters_db + `.departments dep ON dep.dept_id = emp.department_id
        WHERE aas.asset_id >0 `
        if (req.assetsCode) {
            getEntities = getEntities + 'and aas.assets_code = "' + req.assetsCode + '"'
        }
        if (req.location) {
            getEntities = getEntities + 'and lo.location_name = "' + req.location + '"'
        }
        if (req.assetType) {
            getEntities = getEntities + 'and aas.asset_type = "' + req.assetType + '"'
        }
        if (req.department) {
            getEntities = getEntities + 'and dep.dept_name = "' + req.department + '"'
        }
        if (req.assetCategory) {
            getEntities = getEntities + 'and isc.item_sub_category = "' + req.assetCategory + '"'
        }
        if (req.employeeId) {
            getEntities = getEntities + 'and ass.approved_by = ' + req.employeeId + ''
        }
        if (req.plantId > 0 && req.plantId != 5) {
            getEntities = getEntities + ' and aas.plant = ' + req.plantId + ''
        }
        getEntities = getEntities + ` ORDER BY it.item_name ASC`
        const data = await manager.query(getEntities)
        if (data?.length > 0) {
            return new CommonResponse(true, 1, 'Data Retrieved Successfully', data)
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }

    }

    async getassetCodeDropDownforAssetSale(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT aas.asset_id,aas.assets_code,aas.assets_name,aas.plant,it.item_name,aas.asset_category,aas.status
        FROM `+ appSettings.assets_db + `.assets aas
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name
        WHERE aas.status = '${AssetStatusEnum.RETIRED}' or aas.status = '${AssetStatusEnum.DAMAGED}' or aas.status = '${AssetStatusEnum.INSTOCK}'`
        if (req.assetCode) {
            getEntities = getEntities + ' and aas.assets_code = "' + req.assetCode + '"'
        }
        if (req.plantId && req.plantId !== 5) {
            getEntities = getEntities + ' and aas.plant = ' + req.plantId + ''
        }
        if (req.assetCategory) {
            getEntities = getEntities + ' and aas.asset_category = ' + req.assetCategory + ''
        }
        getEntities = getEntities + ' ORDER BY it.item_name'
        const assetdata = await manager.query(getEntities);

        return new CommonResponse(true, 1, 'Data retrieved successfully', assetdata)
    }

    async getassetCategoryDropDownforAssetSale(req?: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT aas.asset_id,aas.assets_code,aas.assets_name,aas.plant,aas.asset_category,isc.item_sub_category,isc.item_sub_category_id
        FROM `+ appSettings.assets_db + `.assets aas
        LEFT JOIN `+ appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        WHERE aas.asset_id >0`
        if (req.plantId && req.plantId !== 5) {
            getEntities = getEntities + ' and aas.plant = ' + req.plantId + ''
        }
        getEntities = getEntities + ' GROUP BY isc.item_sub_category ORDER BY isc.item_sub_category ASC'
        const assetdata = await manager.query(getEntities);

        return new CommonResponse(true, 1, 'Data retrieved successfully', assetdata)
    }

    async assetCodeDropdownforAssetSaleGrid(req: AssetByStatus): Promise<CommonResponse> {
        const manager = getManager();
        let getEntities = `SELECT ass.asset_sale_id,ass.asset_id,aas.assets_code,aas.assets_name,it.item_name
        FROM `+ appSettings.assets_db + `.assets_sale ass
        LEFT JOIN `+ appSettings.assets_db + `.assets aas ON aas.asset_id = ass.asset_id
        LEFT JOIN `+ appSettings.masters_db + `.items it ON it.item_id = aas.assets_name`
        if (req.plantId && req.plantId !== 5) {
            getEntities = getEntities + ' and aas.plant = ' + req.plantId + ''
        }
        getEntities = getEntities + ' ORDER BY aas.assets_code ASC'
        const assetdata = await manager.query(getEntities);
        return new CommonResponse(true, 1, 'Data retrieved successfully', assetdata)
    }

}